import classNames from "classnames";

export const BaseSizedContainer = ({
  width,
  height,
  className,
  children,
  overridingCompponent,
  allowGrow = false,
  documentRef,
}: {
  width: number;
  height: number;
  className?: string;
  children?: React.ReactNode;
  overridingCompponent?: React.ReactNode;
  allowGrow?: boolean;
  documentRef?: React.RefObject<HTMLDivElement>;
}) => (
  <div className="flex-col-center w-full h-full" ref={documentRef}>
    <div
      className="flex-row-center h-full"
      style={{
        aspectRatio: `${width} / ${height}`,
        width: allowGrow ? "100%" : undefined,
        maxWidth: allowGrow ? `${width}px` : `min(100%, ${width}px)`,
      }}
    >
      <div
        className={classNames("relative w-full", className)}
        style={{
          aspectRatio: `${width} / ${height}`,
          height: allowGrow ? "100%" : undefined,
          maxHeight: allowGrow ? `${height}px` : `min(100%, ${height}px)`,
        }}
      >
        {children}
        {overridingCompponent ? (
          <div className="absolute inset-0 z-10">{overridingCompponent}</div>
        ) : null}
      </div>
    </div>
  </div>
);
